import useAsyncFn from 'react-use/lib/useAsyncFn';

import { LoginIdAvailabilityError } from '../signupUtils';

export function useValidateAccountName() {
  return useAsyncFn(
    async ({ loginId, inviteId }: { loginId: string; inviteId?: string }) => {
      let url = `https://onboarding.confidence.dev/v1/loginIdAvailability:check?login_id=${loginId}`;

      if (inviteId) {
        url += `&invite=accountInvites%2f${inviteId}`;
      }

      let response: Response;
      try {
        response = await fetch(url);
      } catch (error) {
        throw new LoginIdAvailabilityError(error, loginId, { failOpen: true });
      }

      if (!response.ok) {
        throw new LoginIdAvailabilityError(
          new Error('Workspace availability check failed'),
          loginId,
          { failOpen: false },
        );
      }

      let availability: unknown;
      try {
        availability = await response.json();
      } catch (error) {
        throw new LoginIdAvailabilityError(error, loginId, {
          failOpen: false,
        });
      }

      if (
        typeof availability !== 'object' ||
        availability === null ||
        !('available' in availability) ||
        typeof availability.available !== 'boolean' ||
        ('message' in availability &&
          availability.message !== undefined &&
          typeof availability.message !== 'string')
      ) {
        throw new LoginIdAvailabilityError(
          new Error('Invalid workspace availability response'),
          loginId,
          { failOpen: false },
        );
      }

      return {
        available: availability.available,
        message:
          'message' in availability && typeof availability.message === 'string'
            ? availability.message
            : undefined,
        loginId,
      };
    },
    [],
  );
}
